import React from "react";

import Actions from "./Actions";

const columns = [
  {
    name: "Topic Name",
    selector: "attributes.title",
    sortable: true,
  },
  {
    name: "Description",
    selector: "attributes.description",
    sortable: true,
  },
  {
    name: "Subtopics",
    selector: "attributes.subtopics_count",
    sortable: true,
  },

  {
    name: "Actions",
    sortable: false,
    width: "100px",
    cell: (row) => <Actions row={row} />,
  },
];

export default columns;
